/**
 * The screens carry bare token keys; which namespace they come from is the
 * segment's answer.
 *
 * A key that already names a namespace is copy both segments share, and is left
 * alone. null stays null, so a state that names no label of its own lets the
 * host supply a generic one.
 */
export function psd2Token(key, isBusiness) {
    if (!key) {
        return null;
    }
    return key.includes(":") ? key : `${isBusiness ? "b2b" : "bnpl"}:${key}`;
}
